import { responseError } from '@/utils/errors';
import findResult, { assignIfExists } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { findAllDatasets } from '../../state/shared';
import actions from '../constants';

const fetchDatasetStatusError = withDraft((draft, action) => {
  findAllDatasets(draft, { items: [{ code: action.code }] }).forEach((category) => {
    const item = findResult(draft.datasets, category, action.code);
    assignIfExists(item.status, { readStatus: states.ERROR, readErrors: [responseError(action)] });
  });
});

const fetchDatasetStatusSuccess = withDraft((draft, { code, result }) => {
  findAllDatasets(draft, { items: [{ code }] }).forEach((category) => {
    const item = findResult(draft.datasets, category, code);
    assignIfExists(item, { status: result });
  });
});

export default {
  [actions.FETCH_DATASET_STATUS_ERROR]: fetchDatasetStatusError,
  [actions.FETCH_DATASET_STATUS_SUCCESS]: fetchDatasetStatusSuccess,
};
